import styled from "styled-components";
import {MiniControlCenterDefaultBox} from "./mini-control-center.default.box";

export const MiniControlCenterMrGreenBox = styled(MiniControlCenterDefaultBox)`
  background: ${props => props.theme.colors.brandSecondary};
`;